import React from "react";
import styles from "./style.module.scss";

interface RadioSliderProps {
  title: string;
  min: number;
  max: number;
  step?: number;
  value: number;
  defaultValue: number;
  onChange: (value: number) => void;
  disabled?: boolean;
  showValue?: boolean;
}

export default function RadioSlider({
  title,
  min,
  max,
  step,
  value,
  defaultValue,
  onChange,
  disabled = false,
  showValue = true,
}: RadioSliderProps) {
  const fillPercent = ((value - min) / (max - min)) * 100;

  return (
    <div className={styles.container}>
      <span className={styles.title}>{title}</span>
      <input
        type="range"
        className={styles.slider}
        min={min}
        max={max}
        step={step ?? "any"}
        value={value}
        onChange={(e) => onChange(parseFloat(e.target.value))}
        disabled={disabled}
        style={{ "--fill-percent": `${fillPercent}%` } as React.CSSProperties}
      />
      {showValue && <span className={styles.value}>{value.toFixed(2)}</span>}
      <button
        className={styles.resetButton}
        onClick={() => onChange(defaultValue)}
        disabled={disabled || value === defaultValue}
        title="Reset to default"
      >
        Reset
      </button>
    </div>
  );
}
